import $ from 'jquery';
import _ from 'lodash';
import commonStore from '../../store/commonStore.js';

export const checkDomEntitlement = (dom: any) => {
    const currentEle = $(dom);
    const initialData = commonStore.getState().asyncStateReducer.initialData;
    const componentName: any = currentEle.attr('data-entitlement');
    const isEntitled = initialData.isEntitled(componentName);
    const isdeaden = initialData.isDeaden(componentName);
    if (!isEntitled && !isdeaden) {
        currentEle.hide();
        return;
    }
    if (isdeaden) {
        currentEle.addClass('deaden');
        currentEle.removeAttr('href');
        currentEle.removeAttr("onclick").off("click");
        const aTag = currentEle.find('a');
        $.each(aTag, (i: number, aTagNode: any) => {
            $(aTagNode).removeAttr('href');
            $(aTagNode).removeAttr('onClick');
            $(aTagNode).css('color','#757575');
        });

        if (_.isEmpty((currentEle.attr('title')))) {
            currentEle.removeAttr('title');
        }
        /*var contentString = "The selected item is an entitled premium service available for clients with:<br>"
            +"-	Global Access Platinum<br>"
            +"-	Global Access<br>"
            +"-	Regional Platinum Tier<br>"
            +"-	Regional Gold Tier<br>";
        if(componentName == "REQUEST_COMPANY_MODEL"){
            contentString+="- Regional Silver Tier";
        }	*/
        // if (componentName.indexOf('ANALYST') < 0 && currentEle.attr('id') !== 'uncoming-events') {
            // setTimeout(function () {
            //     HTML_RENDITION.scriptsLazyLoadedPromise()
            //         .done(function () {

            //             var targetEl = (componentName == "EVENTS") ? currentEle.find('.more-info') : currentEle;
            //             var toolTip = {};
            //             if (componentName == 'REQUEST_CORPORATE_ACCESS') {
            //                 toolTip.content = HTML_RENDITION.request_corporate_access_entitlement_message;
            //             } else if (componentName == 'REQUEST_COMPANY_MODEL') {
            //                 toolTip.content = HTML_RENDITION.request_company_model_entitlement_message;
            //             } else {
            //                 toolTip.content = HTML_RENDITION.request_contact_entitlement_message;
            //             }

            //             targetEl.tooltip(toolTip);

            //             var getTargetElOffset = targetEl.offset();
            //             var positionObj = getTargetElOffset.left > 1150 ? { my: "left-15 top+20" } : { my: "center top+10", collision: "flipfit" };

            //             targetEl.tooltip({
            //                 track: true,
            //                 position: positionObj
            //             });

            //             if (osdetect && (osdetect.detectSmartPhone() || osdetect.detectTablet())) {
            //                 toolTip["tooltipClass"] = "deanden-tooltip";
            //                 var closeTooltip = function (e) {
            //                     targetEl.tooltip('close');
            //                     $('body').off('touchstart.outsideTooltip ', closeTooltip);
            //                 };

            //                 targetEl.tooltip(toolTip)
            //                     .off("mouseover")
            //                     .on("click", function () {
            //                         $(this).attr('title', '');
            //                         var isToolTipExist = $('.deanden-tooltip').length > 0;
            //                         if (isToolTipExist) {
            //                             $('.deanden-tooltip').remove();
            //                         }
            //                         $(this).tooltip('open');
            //                         $('body').on('touchstart.outsideTooltip', closeTooltip);
            //                         return false;
            //                     });
            //             }

            //         });
            // });
        // }
    }
    setTimeout(() => {
        if (isdeaden) {
            console.log('setting title attr');
            currentEle.removeAttr('title');
        }
    });

    return '';
};
